import { memo } from 'react';
import { useIntl } from 'react-intl';
import { Banner } from '@cbhq/cds-web/alpha/banner/Banner';
import { TextLabel2 } from '@cbhq/cds-web/typography';

import { messages } from ':fat/components/BalancesBanner/BalancesBannerMessages';

export const BalancesBanner = memo(function BalancesBanner() {
  const { formatMessage } = useIntl();
  return (
    <Banner
      startIcon="info"
      styleVariant="contextual"
      title={formatMessage(messages.title)}
      variant="promotional"
    >
      <TextLabel2 as="p">{formatMessage(messages.description)}</TextLabel2>
    </Banner>
  );
});
